<span class="loading loading-spinner text-primary h-12 w-12"></span>
